import React, { useState } from "react";
import { Modal } from "react-bootstrap";
import { func } from "../../../Utilities/logFunc";
import { getContestByCode, html5GamesUpdateView } from "../../../Utilities/controller";
import moment from "moment";
import { toast } from "react-toastify";
import { errors } from "../../../Utilities/error";
import { useTranslation } from "react-i18next";
import D11Gold from '../../../assets/images/premium_logo.png'

const FreeGamesModal = ({
    selectedGame,
    selectedSubGame,
    showGameModal,
    setShowGameModal,
    joinId
}) => {
    const [show, setShow] = useState(showGameModal);
  let premiumUser = JSON.parse(localStorage.getItem("premiumUser"))
  const { t } = useTranslation()

  const handleClose = async () => {
    var data = {
        htmlGame: selectedSubGame._id,
        logId: joinId,
        status: "end"
    }
    var response = await html5GamesUpdateView(data);
    setShowGameModal((prev) => false);
    setShow(false);
  };

  return (
    <Modal
      show={show}
      onHide={handleClose}
      backdrop="static"
      keyboard={false}
      className={premiumUser ? "premiumUserTournamentModal tournamentModal modal fade" : "tournamentModal modal fade "}

      centered
    >
      <Modal.Body className={`${premiumUser ? "bg-premium text-light" : ""}`}>
        <button
          type="button"
          class="btn-close"
          data-bs-dismiss="modal"
          aria-label="Close"
          onClick={handleClose}
        ></button>
        <div class={`row justify-content-center ${premiumUser ? "bg-premium text-light" : ""}`}>
          <div class="col-11 px-lg-4">
            {
              premiumUser ?
                <div className="text-center">
                  <img style={{ width: '7.5rem', height: '7.5rem' }} src={D11Gold} />
                  {/* <img  style={{width:'7.5rem', height:'7.5rem'}} src={localStorage.getItem("planName") == "Grandmaster" ? D11Gold : Champion} />  */}

                  <h2 className='d11-premium mt-2  mb-4'>{t("tournaments.premium")}</h2>
                </div>
                : ""

            }
            <div class="title">
              <h3 class={premiumUser ? "text-center bodyBoldFont mb-4 pb-3 text-white" : "text-center bodyBoldFont mb-4 pb-3 text-dark"}>
               {selectedGame?.name}
              </h3>
            </div>
            <div class=" text-center">
              <div class="d-flex justify-content-between fw-normal">
                <h4 class={`mb-1 fw-normal ${premiumUser ? "text-light" : "text-dark"}`}>
                <span class="titleIcon me-3">
                    <img src="/assets/images/game-icon-svg.svg" className="h-50" alt="" />
                </span>
                 {selectedSubGame?.name}
                </h4>
                <h4 class={`mb-3 fw-normal ${premiumUser ? "text-light" : "text-dark"}`}>
                  <span>

                  </span>
                  <span>
                    {" "}

                  </span>
                </h4>
              </div>
              <div>
                  <div className="col-12 d11-freeGame-rectangle p-3">
                    <iframe
                      className="h-100 w-100"
                      src={selectedSubGame?.url}
                    ></iframe>
                  </div>
                </div>
            </div>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
}

export default FreeGamesModal;